export default __webpack_public_path__ + "static/media/1111.a344a087.png";